// src/components/CoverPage/RoadmapSection.jsx
import React from "react";
import "./RoadmapSection.css";

const RoadmapSection = () => {
  return (
    <section className="roadmap-section py-20 px-5">
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Project Roadmap
        </h2>

        <div className="max-w-5xl mx-auto">
          {/* Timeline visual */}
          <div className="hidden md:block h-1 bg-gradient-to-r from-indigo-400 to-blue-500 w-full mb-16 relative">
            <div className="absolute -top-2 left-0 w-4 h-4 rounded-full bg-indigo-600"></div>
            <div className="absolute -top-2 left-1/3 w-4 h-4 rounded-full bg-indigo-600"></div>
            <div className="absolute -top-2 left-2/3 w-4 h-4 rounded-full bg-indigo-600"></div>
            <div className="absolute -top-2 right-0 w-4 h-4 rounded-full bg-indigo-600"></div>
          </div>

          {/* Phase boxes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Phase 1: Completed */}
            <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-xl p-6 shadow-xl border border-white border-opacity-20 transform transition hover:scale-105">
              <div className="bg-indigo-600 inline-block rounded-full px-3 py-1 text-sm font-semibold text-white mb-4">
                Completed
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Foundation</h3>
              <ul className="text-white text-opacity-90 space-y-2">
                <li className="flex items-start">
                  <div className="text-indigo-400 mr-2">✓</div>
                  <span>Smart contract development</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-400 mr-2">✓</div>
                  <span>MCIF index fund implementation</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-400 mr-2">✓</div>
                  <span>Governance infrastructure</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-400 mr-2">✓</div>
                  <span>Governance token</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-400 mr-2">✓</div>
                  <span>Decentralized governance system</span>
                </li>
              </ul>
            </div>

            {/* Phase 2: Current */}
            <div className="bg-white bg-opacity-15 backdrop-filter backdrop-blur-lg rounded-xl p-6 shadow-xl border border-white border-opacity-30 transform transition hover:scale-105">
              <div className="bg-blue-500 inline-block rounded-full px-3 py-1 text-sm font-semibold text-white mb-4">
                In Progress
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Optimism Expansion</h3>
              <ul className="text-white text-opacity-90 space-y-2">
                <li className="flex items-start">
                  <div className="text-blue-300 mr-2">→</div>
                  <span>Migration to Optimism Layer 2</span>
                </li>
                <li className="flex items-start">
                  <div className="text-blue-300 mr-2">→</div>
                  <span>Reduced gas fees and faster transactions</span>
                </li>
                <li className="flex items-start">
                  <div className="text-blue-300 mr-2">→</div>
                  <span>New perpetual swap income strategy</span>
                </li>
                <li className="flex items-start">
                  <div className="text-blue-300 mr-2">→</div>
                  <span>Enhanced governance tools</span>
                </li>
                <li className="flex items-start">
                  <div className="text-blue-300 mr-2">→</div>
                  <span>OP token integration</span>
                </li>
              </ul>
            </div>

            {/* Phase 3: Upcoming */}
            <div className="bg-white bg-opacity-5 backdrop-filter backdrop-blur-lg rounded-xl p-6 shadow-xl border border-white border-opacity-10 transform transition hover:scale-105">
              <div className="bg-indigo-400 bg-opacity-60 inline-block rounded-full px-3 py-1 text-sm font-semibold text-white mb-4">
                Coming Soon
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">User-Owned Funds</h3>
              <ul className="text-white text-opacity-90 space-y-2">
                <li className="flex items-start">
                  <div className="text-indigo-300 mr-2">○</div>
                  <span>Create your own index fund with few clicks</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-300 mr-2">○</div>
                  <span>Customizable allocation strategies</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-300 mr-2">○</div>
                  <span>YILDX token-gated management features</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-300 mr-2">○</div>
                  <span>Built on the existing YildX backbone</span>
                </li>
                <li className="flex items-start">
                  <div className="text-indigo-300 mr-2">○</div>
                  <span>Custom fee structures</span>
                </li>
              </ul>
            </div>
          </div>

          {/* New features highlighted section - with proper coloring to match the theme */}
          <div className="mt-16 text-center">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-xl p-6 shadow-lg border border-white border-opacity-20">
                <h4 className="text-xl font-semibold text-white mb-4">Perpetual Swap Interest Generation</h4>
                <p className="text-white text-opacity-80 text-left">
                  Our upcoming funds will leverage perpetual swap protocols to generate sustainable interest income for fund participants. This innovative approach will allow for higher yields while maintaining the diversified exposure benefits of index funds.
                </p>
              </div>
              
              <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-xl p-6 shadow-lg border border-white border-opacity-20">
                <h4 className="text-xl font-semibold text-white mb-4">Customizable Fund Templates</h4>
                <p className="text-white text-opacity-80 text-left">
                  YILDX token holders will be able to choose from various fund templates or create their own with custom parameters, allocation strategies, and fee structures - all powered by the battle-tested YildX protocol infrastructure.
                </p>
              </div>
            </div>

            <p className="mt-10 text-white text-opacity-90 italic max-w-2xl mx-auto">
              "Our vision is to create a platform where anyone can launch and manage their own crypto index fund with the security and transparency of the blockchain"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;